<template>
  <div class="loucengfenbu">
    <img class="no-patient-pic" src="~@/assets/images/no-content.png" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'LouCengFenBu',
  data() {
    return {

    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.loucengfenbu {
  text-align: center;
  margin-top: 1rem;
  p{
    line-height: 1rem;
  }
}
</style>
